import React from "react";
import { Route, Redirect } from "react-router-dom";
import AllModels from "../pages/Common/AllModels";
const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (isAuthProtected && !localStorage.getItem("access_token")) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      } else if (!isAuthProtected) {
        return (
          <Layout>
            <Component {...props} />
          </Layout>
        );
      } else {
        return (
          <Layout>
            <Component {...props} />
            <AllModels {...props} />
          </Layout>
        );
      }
    }}
  />
);

export default AppRoute;
